import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './organisationMember.html?raw';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';
import topic from 'dojo/topic';
import organisationMember_row from './organisationMember_row/organisationMember_row';
import "./organisationMember_row/organisationMember_row";


class organisationMember extends compose(_LabelInputBase) {
    templateString: any = template;

    rows_container: HTMLElement;
    addRow_button: HTMLButtonElement;

    maxRowsQuantity: number = 3;
    isValid: boolean = true;

    _value: Array<{ rowId: string, value: object}> = [];

    allRows: Array<MdsLax<InstanceType<typeof organisationMember_row>>> = [];

    createNewRow(): void {

        let row = new organisationMember_row();

        this.allRows.push(row);

        if (this.allRows.length == 1) {
            row._hideDeleteButton(true);
        }

        row.on("rowValueChange", lang.hitch(this, function (row) {
            this._onValueChange_row(row);
        }));

        row.placeAt(this.rows_container);

    }

    _onValueChange_row(row: MdsLax<InstanceType<typeof organisationMember_row>>): void { 

        let foundIt: boolean = false;

        for (let valueObj of this._value) {
            if (valueObj.rowId == row.id) {
                foundIt = true;
                valueObj.value = row.getValue();
            }
        }

        if (foundIt == false) {
            this._value.push({ rowId: row.id, value: row.getValue() });
        }

        this._onChange();
    }

    _deleteRow(row: MdsLax<InstanceType<typeof organisationMember_row>>): void {

        let rowIndex: number = -1;

        for (let i = 0; i < this.allRows.length; i++) {
            if (this.allRows[i].id == row.id) {

                if (i > 0) { // die erste person soll unter keinen Umständen entfernt werden
                    this.allRows.splice(i, 1);
                    row.destroy();
                }

                if (!this._value.length) {
                    console.log("no _value.length. Why?");
                    return;
                } else {
                    let valueIndex: number = -1;
                    for (let j = 0; j < this._value.length; j++) {
                        if (this._value[j].rowId == row.id) {
                            valueIndex = j;
                        }
                    }
                    if (valueIndex > -1) {
                        this._value.splice(valueIndex, 1);
                    }
                }
            }
        }

        this._onChange();
    }

    dataCompletenessCheck(): boolean {
        let result: boolean = true;

        if (this.isMandatory) {
            for (let row of this.allRows) {
                if (row.dataCompletnessCheck() == false) {
                    result = false;
                }
            }
        }

        this.isValid = result;

        return result;
    }

    validateInput(): boolean {
        let result: boolean = true;

        if (this.isMandatory) {
            for (let row of this.allRows) {
                if (row.validateInput() == false) {
                    result = false;
                }
            }
        }

        this.isValid = result;
       
        return result;
    }

    getValue(): Array<object> {
        let returnValue: Array<object> = [];

        for (let _valueObj of this._value) {
            returnValue.push(_valueObj.value);
        }

        return returnValue;
    }

    _onChange(): void {
        this.emit("valueChange");
    }

    clearRows(): void {
        if (this.allRows && this.allRows.length) {
            for (let i = 0; i < this.allRows.length; i++) {
                this.allRows[i].destroy();
            } 
        }

        this.allRows = [];
        this.rows_container.innerHTML = null;
    }


    _onClick_addRow_button(): void {
        let mayCreate: boolean = true;

        for (let row of this.allRows) {
            if (row.validateInput() == false) {
                mayCreate = false;
            }
        }

        if (mayCreate) {
            this.createNewRow();
        } else {
            alert(this.translations["ArtistRegistration__furtherRepresentative_Note"]);
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.createNewRow();

        topic.subscribe("oranisationMember_row/deleteRow", lang.hitch(this, function (row) { this._deleteRow(row) }));
    }
}

export default mdsWidget(organisationMember);